<template>
	<div class="table-main-div">
		<el-table v-drag="dragValue" ref="el_table" :data="tableData" id="weekly-keywords-id"
			header-row-class-name="tab-202205300628-th" row-class-name="tab-202205300628-tr" class="tab-202206110508">
			<el-table-column width="100" label="#" align="center">
				<template slot-scope="scpoe">
					<span style="color: #C0C4CC">
					{{ (searchCriteria.page - 1) * searchCriteria.pageSize + (scpoe.$index + 1) }}
					</span>
				</template>
			</el-table-column>
			
			<el-table-column :label="$t('aba.columns.search_term.name')" min-width="250px" :header-align="get_table_header_align()">
				<template slot="header" slot-scope="scope">
					<span>{{$t('aba.columns.search_term.name')}}</span>
					<el-popover trigger="hover" placement="top">
						<div style=" color: #909399;">
							{{$t('aba.columns.search_term.tips')}}
						</div>
						<i slot="reference" class="fa fa-question-circle-o" aria-hidden="true"></i>
					</el-popover>
				</template>
				<template slot-scope="scope">
					<table-keywords-column :keywords="scope.row.search_term" :country="country"
						@clickAsin="searchSearchASIN" @clickKeywords="searchSearchItem"
						:translation="chineseTranslationObj" :fold="scope.row.fold"></table-keywords-column>
				</template>
			</el-table-column>

			<el-table-column :label="$t('aba.columns.search_frequency_rank.name')" width="140px" :header-align="get_table_header_align()" align="center"
				prop="search_frequency_rank">
				<template slot="header" slot-scope="scope">
					<span>{{$t('aba.columns.search_frequency_rank.name')}}</span>
					<el-popover trigger="hover" placement="top">
						<div style=" color: #909399;">
							{{$t('aba.columns.search_frequency_rank.tips')}}
						</div>
						<i slot="reference" class="fa fa-question-circle-o" aria-hidden="true"></i>
					</el-popover>
					<span class="sort-span">
						<i v-if="sortBy.indexOf('search_frequency_rank:asc') != -1 || sortBy.length == 0"
							@click="sortClick('search_frequency_rank:',1)" class="el-icon-caret-top"></i>
						<i v-if="sortBy.indexOf('search_frequency_rank:desc') != -1"
							@click="sortClick('search_frequency_rank:',0)" class="el-icon-caret-bottom"></i>
					</span>
				</template>
				<template slot-scope="scope">
					<el-tooltip effect="light" content="点击查看搜索排名历史趋势" placement="top">
						<span @click="openChartDialog(scope.row.search_term,'1',country)"
							class=" underline-dotted-line open-chart-span" style="font-size: 16px">
							{{ toThousands(scope.row.search_frequency_rank) }}
						</span>
					</el-tooltip>
				</template>
			</el-table-column>

			<el-table-column :label="$t('aba.columns.search_frequency_rank_growth_metrics.name')" width="170" :header-align="get_table_header_align()" align="center">
				<template slot="header" slot-scope="scope">
					<span>{{$t('aba.columns.search_frequency_rank_growth_metrics.name')}}</span>
					<el-popover trigger="hover" placement="top">
						<div style=" color: #909399;">
							{{$t('aba.columns.search_frequency_rank_growth_metrics.tips')}}
						</div>
						<i slot="reference" class="fa fa-question-circle-o" aria-hidden="true"></i>
					</el-popover>
				</template>
				<template slot-scope="scope">
					<div>
						<div v-if="scope.row.domLazy && scope.row.search_frequency_rank_growth_metrics">
							<chart-sub :data_height="80"
								:option="getRankTrendsOptions(scope.row.search_frequency_rank_growth_metrics)"></chart-sub>
						</div>
						<div v-else class="loading-div">
							<i class="el-icon-loading"></i>
						</div>
					</div>
				</template>
			</el-table-column>
			<!--排名涨跌-->
			<el-table-column :label="$t('aba.columns.search_frequency_rank_change.name')" width="125" :header-align="get_table_header_align()" align="center">
				<template slot="header" slot-scope="scope">
					<span>{{$t('aba.columns.search_frequency_rank_change.name')}}</span>
					<el-popover trigger="hover" placement="top">
						<div style=" color: #909399;">
							<p>
								<font color="#303133">
									{{$t('aba.columns.search_frequency_rank_change.tips')}}
								</font>
							</p>
							<p>
								<font color="#67C23A">
									<i class="fa fa-long-arrow-up"></i>
								</font>
								{{$t('aba.columns.search_frequency_rank_change.addons.green')}}</p>
							<p>
								<font color="#cf1322">
									<i class="fa fa-long-arrow-down"></i>
								</font>
								{{$t('aba.columns.search_frequency_rank_change.addons.red')}}</p>
						</div>
						<i slot="reference" class="fa fa-question-circle-o" aria-hidden="true"></i>
					</el-popover>
				</template>
				<template slot-scope="scope">
					<div class="last-week-ranking" v-if="scope.row.domLazy">
						<!-- 上周排名涨跌 -->
						<el-popover trigger="hover" placement="top">
							<div class="ranking-up-popover-div">
								相对上周排名涨跌
								<p>
									时间 :
									<font color="#F56C6C">{{ fomatTimeStr(scope.row.lastWeek.date) }}</font>
								</p>
								<el-col :span="12">
									排名 :
									<span v-if="scope.row.lastWeek.value != null">
										{{ toThousands(Math.abs(scope.row.search_frequency_rank + scope.row.lastWeek.value)) }}
									</span>
									<span v-else>
										<font class="no-data-font">{{ '--' }}</font>
									</span>
								</el-col>
								<el-col :span="12">
									涨跌 :
									<span v-if="scope.row.lastWeek.value != null">
										<font color="#67C23A" v-if="scope.row.lastWeek.value > 0">
											<i class="fa fa-long-arrow-up"></i>
											{{ toThousands(Math.abs(scope.row.lastWeek.value)) }}
										</font>
										<font
											v-else-if="scope.row.lastWeek.value === 0">
											<font class="no-data-font">{{ '--' }}</font>
										</font>
										<font v-else color="#cf1322">
											<i class="fa fa-long-arrow-down"></i>
											{{ toThousands(Math.abs(scope.row.lastWeek.value)) }}
										</font>
									</span>
									<span v-else>
										<font class="no-data-font">{{ '--' }}</font>
									</span>
								</el-col>
							</div>
							<div slot="reference">
								<span v-if="scope.row.lastWeek.value != null">
									<font color="#67C23A" v-if="scope.row.lastWeek.value > 0">
										<i class="fa fa-long-arrow-up"></i>
										{{ toThousands(Math.abs(scope.row.lastWeek.value)) }}
									</font>
									<font v-else-if="scope.row.lastWeek.value === 0">
										<font class="no-data-font">{{ '--' }}</font>
									</font>
									<font v-else color="#cf1322">
										<i class="fa fa-long-arrow-down"></i>
										{{ toThousands(Math.abs(scope.row.lastWeek.value)) }}
									</font>
								</span>
								<span v-else>
									<font class="no-data-font">{{ '--' }}</font>
								</span>
							</div>
						</el-popover>
						<!-- 上个月排名涨跌 -->
						<el-popover trigger="hover" placement="top">
							<div class="ranking-up-popover-div">
								相对上月排名涨跌
								<p>
									时间 :
									<font color="#F56C6C">{{ fomatTimeStr(scope.row.lastMonth.date) }}</font>
								</p>
								<el-col :span="12">
									排名 :
									<span v-if="scope.row.lastMonth.value != null">
										{{ toThousands(Math.abs(scope.row.search_frequency_rank + scope.row.lastMonth.value)) }}
									</span>
									<span v-else>
										<font class="no-data-font">{{ '--' }}</font>
									</span>
								</el-col>
								<el-col :span="12">
									涨跌 :
									<span v-if="scope.row.lastMonth.value != null">
										<font color="#67C23A" v-if="scope.row.lastMonth.value > 0">
											<i class="fa fa-long-arrow-up"></i>
											{{ toThousands(Math.abs(scope.row.lastMonth.value)) }}
										</font>
										<font
											v-else-if="scope.row.lastMonth.value === 0">
											<font class="no-data-font">{{ '--' }}</font>
										</font>
										<font v-else color="#cf1322">
											<i class="fa fa-long-arrow-down"></i>
											{{ toThousands(Math.abs(scope.row.lastMonth.value)) }}
										</font>
									</span>
									<span v-else>
										<font class="no-data-font">{{ '--' }}</font>
									</span>
								</el-col>
							</div>

							<div slot="reference">
								<span v-if="scope.row.lastMonth.value != null">
									<font color="#67C23A" v-if="scope.row.lastMonth.value > 0">
										<i class="fa fa-long-arrow-up"></i>
										{{ toThousands(Math.abs(scope.row.lastMonth.value)) }}
									</font>
									<font v-else-if="scope.row.lastMonth.value === 0">
										<font class="no-data-font">{{ '--' }}</font>
									</font>
									<font v-else color="#cf1322">
										<i class="fa fa-long-arrow-down"></i>
										{{ toThousands(Math.abs(scope.row.lastMonth.value)) }}
									</font>
								</span>
								<span v-else>
									<font class="no-data-font">{{ '--' }}</font>
								</span>
							</div>
						</el-popover>
						<!-- 三个月前排名涨跌 -->
						<el-popover trigger="hover" placement="top">
							<div class="ranking-up-popover-div">
								相对上季排名涨跌
								<p>
									时间 :
									<font color="#F56C6C">{{ fomatTimeStr(scope.row.threeMonthsAgo.date) }}</font>
								</p>
								<el-col :span="12">
									排名 :
									<!-- <span v-if="scope.row.threeMonthsAgo.value && scope.row.threeMonthsAgo.value < 1000000"> -->
									<span v-if="scope.row.threeMonthsAgo.value != null">
										{{ toThousands(Math.abs(scope.row.search_frequency_rank + scope.row.threeMonthsAgo.value)) }}
									</span>
									<span v-else>
										<font class="no-data-font">{{ '--' }}</font>
									</span>
								</el-col>
								<el-col :span="12">
									涨跌 :
									<span v-if="scope.row.threeMonthsAgo.value != null">
										<font color="#67C23A" v-if="scope.row.threeMonthsAgo.value > 0">
											<i class="fa fa-long-arrow-up"></i>
											{{ toThousands(Math.abs(scope.row.threeMonthsAgo.value)) }}
										</font>
										<font
											v-else-if="scope.row.threeMonthsAgo.value === 0">
											<font class="no-data-font">{{ '--' }}</font>
										</font>
										<font v-else color="#cf1322">
											<i class="fa fa-long-arrow-down"></i>
											{{ toThousands(Math.abs(scope.row.threeMonthsAgo.value)) }}
										</font>
									</span>
									<span v-else>
										<font class="no-data-font">{{ '--' }}</font>
									</span>
								</el-col>
							</div>

							<div slot="reference">
								<span v-if="scope.row.threeMonthsAgo.value != null">
									<font color="#67C23A" v-if="scope.row.threeMonthsAgo.value > 0">
										<i class="fa fa-long-arrow-up"></i>
										{{ toThousands(Math.abs(scope.row.threeMonthsAgo.value)) }}
									</font>
									<font v-else-if="scope.row.threeMonthsAgo.value === 0">
										<font class="no-data-font">{{ '--' }}</font>
									</font>
									<font v-else color="#cf1322">
										<i class="fa fa-long-arrow-down"></i>
										{{ toThousands(Math.abs(scope.row.threeMonthsAgo.value)) }}
									</font>
								</span>
								<span v-else>
									<font class="no-data-font">{{ '--' }}</font>
								</span>
							</div>
						</el-popover>
					</div>
				</template>
			</el-table-column>

			<el-table-column :label="$t('aba.columns.clicked_category.name')" align="right" :header-align="get_table_header_align()" width="100">
				<template slot-scope="scope">
					<div style="font-size: 12px;">
						<div>
							<div v-if="scope.row.clicked_category[1]">
								<div style="cursor: pointer">
									<copy-sub :show="true" :content="'点击将 ' + scope.row.clicked_category[1].category + ' 复制到剪切板'"
										:value="scope.row.clicked_category[1].category">
										<div class="overflow-one-line">{{ scope.row.clicked_category[1].category }}</div>
									</copy-sub>
								</div>
								<!-- <el-tooltip class="item" effect="dark" placement="top">
									<div slot="content">
										{{ scope.row.clicked_category[1].category }}
									</div>
									<div class="overflow-one-line">{{ scope.row.clicked_category[1].category }}</div>
								</el-tooltip> -->
							</div>
							<span v-else class="no-data-font-1"></span>
						</div>
						<div>
							<div v-if="scope.row.clicked_category[2]">
								<div style="cursor: pointer">
									<copy-sub :show="true" :content="'点击将 ' + scope.row.clicked_category[2].category + ' 复制到剪切板'"
										:value="scope.row.clicked_category[2].category">
										<div class="overflow-one-line">{{ scope.row.clicked_category[2].category }}</div>
									</copy-sub>
								</div>
								<!-- <el-tooltip class="item" effect="dark" placement="top">
									<div slot="content">
										{{ scope.row.clicked_category[2].category }}
									</div>
									<div class="overflow-one-line">{{ scope.row.clicked_category[2].category }}</div>
								</el-tooltip> -->
							</div>
							<span v-else class="no-data-font-1"></span>
						</div>
						<div>
							<div v-if="scope.row.clicked_category[3]">
								<div style="cursor: pointer">
									<copy-sub :show="true" :content="'点击将 ' + scope.row.clicked_category[3].category + ' 复制到剪切板'"
										:value="scope.row.clicked_category[3].category">
										<div class="overflow-one-line">{{ scope.row.clicked_category[3].category }}</div>
									</copy-sub>
								</div>
								<!-- <el-tooltip class="item" effect="dark" placement="top">
									<div slot="content">
										{{ scope.row.clicked_category[3].category }}
									</div>
									<div class="overflow-one-line">{{ scope.row.clicked_category[3].category }}</div>
								</el-tooltip> -->
							</div>
							<span v-else class="no-data-font-1"></span>
						</div>
					</div>
				</template>
			</el-table-column>

			<el-table-column :label="$t('aba.columns.clicked_brand.name')" align="right" :header-align="get_table_header_align()" width="100">
				<template slot-scope="scope">
					<div style="font-size: 12px" class="overflow-one-line">
						<div>
							<!-- <div v-if="isVip(loginUser)"> -->
								<brand-sub :key="country+'_'+scope.row.search_term+'_'+scope.row.clicked_brand[1].brand" :searchP="{ country : country, brand : scope.row.clicked_brand[1].brand ,keyword : scope.row.search_term }"
									v-if="scope.row.clicked_brand[1]">
									<div style="cursor: pointer">
										<copy-sub :show="false" :content="'点击将 ' + scope.row.clicked_brand[1].brand + ' 复制到剪切板'"
											:value="scope.row.clicked_brand[1].brand">
											<div class="overflow-one-line">{{ scope.row.clicked_brand[1].brand }}</div>
										</copy-sub>
									</div>
								</brand-sub>
								<span v-else class="no-data-font-1"></span>
							<!-- </div> -->
							<!-- <div v-else>
								<span v-if="scope.row.clicked_brand[1]">
									<div style="cursor: pointer">
										<copy-sub :show="false" :content="'点击将 ' + scope.row.clicked_brand[1].brand + ' 复制到剪切板'"
											:value="scope.row.clicked_brand[1].brand">
											<div class="overflow-one-line">{{ scope.row.clicked_brand[1].brand }}</div>
										</copy-sub>
									</div>
								</span>
								<span v-else class="no-data-font-1"></span>
							</div> -->
						</div>
						<div>
							<!-- <div v-if="isVip(loginUser)"> -->
								<brand-sub :key="country+'_'+scope.row.search_term+'_'+scope.row.clicked_brand[2].brand" :searchP="{ country : country, brand : scope.row.clicked_brand[2].brand ,keyword : scope.row.search_term }"
									v-if="scope.row.clicked_brand[2]">
									<div style="cursor: pointer">
										<copy-sub :show="false" :content="'点击将 ' + scope.row.clicked_brand[2].brand + ' 复制到剪切板'"
											:value="scope.row.clicked_brand[2].brand">
											<div class="overflow-one-line">{{ scope.row.clicked_brand[2].brand }}</div>
										</copy-sub>
									</div>
								</brand-sub>
								<span v-else class="no-data-font-1"></span>
							<!-- </div> -->
							<!-- <div v-else>
								<span v-if="scope.row.clicked_brand[2]">
									<div style="cursor: pointer">
										<copy-sub :show="false" :content="'点击将 ' + scope.row.clicked_brand[2].brand + ' 复制到剪切板'"
											:value="scope.row.clicked_brand[2].brand">
											<div class="overflow-one-line">{{ scope.row.clicked_brand[2].brand }}</div>
										</copy-sub>
									</div>
								</span>
								<span v-else class="no-data-font-1"></span>
							</div> -->
						</div>
						<div>
							<!-- <div v-if="isVip(loginUser)"> -->
								<brand-sub :key="country+'_'+scope.row.search_term+'_'+scope.row.clicked_brand[3].brand" :searchP="{ country : country, brand : scope.row.clicked_brand[3].brand ,keyword : scope.row.search_term }"
									v-if="scope.row.clicked_brand[3]">
									<div style="cursor: pointer">
										<copy-sub :show="false" :content="'点击将 ' + scope.row.clicked_brand[3].brand + ' 复制到剪切板'"
											:value="scope.row.clicked_brand[3].brand">
											<div class="overflow-one-line">{{ scope.row.clicked_brand[3].brand }}</div>
										</copy-sub>
									</div>
								</brand-sub>
								<span v-else class="no-data-font-1"></span>
							<!-- </div> -->
							<!-- <div v-else>
								<span v-if="scope.row.clicked_brand[3]">
									<div style="cursor: pointer">
										<copy-sub :show="false" :content="'点击将 ' + scope.row.clicked_brand[3].brand + ' 复制到剪切板'"
											:value="scope.row.clicked_brand[3].brand">
											<div class="overflow-one-line">{{ scope.row.clicked_brand[3].brand }}</div>
										</copy-sub>
									</div>
								</span>
								<span v-else class="no-data-font-1"></span>
							</div> -->
						</div>
					</div>
				</template>
			</el-table-column>

			<el-table-column :label="$t('aba.columns.clicked_asin_metrics.name')" width="130" :header-align="get_table_header_align()" align="right">
				<template slot="header" slot-scope="scope">
					<font size="2">
						{{$t('aba.columns.clicked_asin_metrics.name')}}
						<el-popover placement="top" width="500" trigger="hover">
							<div style="color: #909399;">
								<p><font color="#303133"><b>前三商品点击总占比</b>：
									当前关键词点击排名前三商品的点击占比合计</font></p>

								<p>假设前三点击商品的点击占比分别是：Click1、Click2、Click3</p>
								<p>则前三商品点击总占比 = Click1 + Click2 + Click3</p>
								<p>
									<font color="#303133">
										<b>前三商品转化总占比</b>
										：当前关键词点击排名前三商品的转化占比合计</font></p>
								<p>假设前三点击商品的转化占比分别是：Conv1、Conv2、Conv3 </p>
								<p>则前三商品转化总占比 =Conv1 + Conv2 + Conv3</p>
							</div>
							<i slot="reference" class="fa fa-question-circle-o" aria-hidden="true"></i>
						</el-popover>
					</font>
					<!-- <span class="sort-span">
						<i @click="sortClick('click_share:',0)"
							:class="getSortDescendingCss('click_share:',0) + ' sort-ascending el-icon-caret-top'"></i>
						<i @click="sortClick('click_share:',1)"
							:class="getSortDescendingCss('click_share:',1) + ' sort-descending  el-icon-caret-bottom'"></i>
					</span> -->
				</template>
				<template slot-scope="scope">
					<div style="font-size: 13px; line-height: 25px;width: 50px;margin: auto;">
						<el-tooltip effect="light" content="点击查看前三商品点击总占比历史趋势" placement="top">
							<div>
								<font @click="openChartDialog(scope.row.search_term,'2',country)"
									v-if="scope.row.click_share_sum" class="open-chart-span">
									{{ changeDecimal(scope.row.click_share_sum * 100, '2') }}%
								</font>
								<span v-else class="no-data-font-1"></span>
							</div>
						</el-tooltip>
						<el-tooltip effect="light" content="点击查看前三商品转化总占比历史趋势" placement="top">
							<div>
								<font @click="openChartDialog(scope.row.search_term,'2',country)" color="#909399"
									class="open-chart-span"
									v-if="scope.row.conversion_share_sum">
									{{ changeDecimal(scope.row.conversion_share_sum * 100, 2) }}%
								</font>
								<span v-else class="no-data-font-1"></span>
							</div>
						</el-tooltip>
					</div>
				</template>
			</el-table-column>

			<el-table-column :label="$t('aba.columns.clicked_asin.name')" align="center" width="300px">
				<template slot-scope="scope">
					<div :key="JSON.stringify(scope.row.clicked_asin)">
						<el-row>
							<el-col :span="8" v-for="(item,index) in scope.row.clicked_asin"
								:key="scope.row.search_frequency_rank + ':' + index">
								<div class="asin-box-div" v-if="country == 'US'">
									<asin-info-sub-v1 :country="country" :asinRelated="item"
										:thumbnailLazy="scope.row.domLazy" :keywords="scope.row.search_term"
										@clickAsin="searchSearchASIN"></asin-info-sub-v1>
								</div>
								<div class="asin-box-div" v-else>
									<asin-info-sub :country="country" :asinRelated="item"
										:thumbnailLazy="scope.row.domLazy" :keywords="scope.row.search_term"
										@clickAsin="searchSearchASIN"></asin-info-sub>
								</div>
							</el-col>
						</el-row>
					</div>
				</template>
			</el-table-column>
		</el-table>

		<div class="not-login-shade-div" :style="'height:' + shadowHeight + 'px;'"
			v-if="!loginUser.isLogin && total <= this.searchCriteria.pageSize * this.searchCriteria.page
			&& tableData.length > shadowNum">
			<el-empty>
				<div slot="description" style="text-align: center;">
					<h3>
						<font color="#909399">
							<a href="/sign" style="color: #0063DC;text-decoration: underline;">登录</a>
							后查看全部数据
						</font>
					</h3>
				</div>
			</el-empty>
		</div>
		<!-- 排名图标dialog -->

		<el-dialog width="1200px" v-if="chartDialogObj.visible" :close-on-click-modal="false"
			destroy-on-close :visible.sync="chartDialogObj.visible" top="30px">
			<!--			<keyword-thends-chart-sub :startTime="startTime" :endTime="date[0]" :country="country"-->
			<!--				:activeName="chartDialogObj.activeName"-->
			<!--				:keywords="chartDialogObj.keywords"></keyword-thends-chart-sub>-->
			<keywords-trends-sub :keywords="chartDialogObj.keywords" :country="country"></keywords-trends-sub>
		</el-dialog>

		<el-dialog width="1300px" v-if="asinTrendsObj.visible" :close-on-click-modal="false"
			destroy-on-close :visible.sync="asinTrendsObj.visible" top="30px">

			<asin-trends-sub :asin="asinTrendsObj.asin" ></asin-trends-sub>
		</el-dialog>
	</div>
</template>

<script>
import { changeDecimal, toThousands, unitConversion } from '@/components/common/utils/fomatNum.js'
import Chart from '@/components/template/otherSub/hightChartSub.vue'
import IMG_MAP from '@/components/config/staticImgMap.js'
import ASIN_INFO_SUB from '@/components/template/view/keywordReverseSearch/sub/asinInfoSub.vue'
import ASIN_INFO_SUB_V1 from '@/components/template/view/keywordReverseSearch/sub/asinInfoSubV1.vue'
import BRAND_SUB from '@/components/template/view/keywordReverseSearch/sub/brandTableSub'
import COPY_SUB from '@/components/template/otherSub/copySub.vue'
import { fomatRankTrendsDataMini, fomatRankTrendsDataMiniV2 } from '@/components/config/chart/keywordRankTrendsMini.js'
import { dateAdd, fomatTimeStr, getWeekFirstDay, getWeekLastDay } from '@/components/common/utils/time.js'
import { getCountryObjByCity } from "@/components/config/countryCodeConfig";
import TABLE_KEYWORDS_COLUMN from "@/components/template/view/reverse/sub/tableKeywordColumn";
import { keywordChartMethods } from "@/components/template/view/keywordReverseSearch/mixins/weeklyKeywords";
import KEYWORD_TRENDS from '@/components/template/view/keywordsTrend/index'
import { isVip } from "@/components/common/member/member";

export default {
	name: 'asinRelatedTable',
	inject: ['F_alertMsg', 'F_windowLoading', 'F_getErrMSg', 'LOGINUSER', 'F_costDialog', 'F_hintAlert'],
	mixins: [keywordChartMethods],
	data() {
		return {
			loginUser: this.LOGINUSER,
			imgMap: IMG_MAP,
			dragValue: {
				left: null,
				top: null,
			},
			shadowHeight: null,
			shadowNum: 10,
			// 翻译纠错建议词
			suggestedWordPopover: true,
			suggestedWord: null,
			suggestedWordRemark: null,
			suggestedWordLoading: false,

		}
	},
	props: {
		tableData: {
			required: true
		},
		country: {
			required: true
		},
		total: {
			required: true
		},
		sortBy: {
			type: Array
		},
		date: {
			required: true
		},
		endTime: {},
		chineseTranslationObj: {
			type: Object,
			default: () => {
			}
		},
		searchCriteria: {
			required: true
		}
	},
	components: {
		'asin-info-sub': ASIN_INFO_SUB,
		'asin-info-sub-v1': ASIN_INFO_SUB_V1,
		'copy-sub': COPY_SUB,
		'chart-sub': Chart,
		'table-keywords-column': TABLE_KEYWORDS_COLUMN,
		'keywords-trends-sub': KEYWORD_TRENDS,
		'brand-sub' : BRAND_SUB
	},
	computed: {},
	created() {
	},
	methods: {
		get_table_header_align() {
			return this.$store.state.app.language == 'zh-CN' ? 'center' : 'left';
		},
		isVip: function(loginUser) {
			return isVip(loginUser)
		},
		sortClick: function(prefix, desc) {
			let name = prefix
			if (desc == 1) {
				name += 'desc'
			} else {
				name += 'asc'
			}
			if (this.sortBy.findIndex(i => i == name) != -1) {
				return
			}
			let index = this.sortBy.findIndex(i => i.indexOf(prefix) >= 0)
			if (index >= 0) {
				this.sortBy.splice(index, 1)
				this.sortBy.push(name)
			} else {
				this.sortBy.push(name)
			}
		},
		getSortDescendingCss: function(prefix, desc) {
			let name = prefix
			let css = 'sort-cart '
			if (desc == 1) {
				name += 'desc'
				css += 'sort-descending'
			} else {
				name += 'asc'
				css += 'sort-ascending'
			}
			let index = this.sortBy.findIndex(i => i == name)
			if (index >= 0) {
				css += ' check-sort '
			}
			return css;
		},
		getRankTrendsOptions: function(list) {
			return fomatRankTrendsDataMini(list)
		},
		getRankTrendsOptionsV2: function(date, list) {
			return fomatRankTrendsDataMiniV2(date, list)
		},
		getWeekFirstDay: function(date) {
			return getWeekFirstDay(date)
		},
		dateAdd: function(date, interval, num) {
			if (!(date instanceof Date)) {
				date = new Date(date)
			}
			return dateAdd(date, interval, num)
		},
		toThousands: function(val) {
			return toThousands(val)
		},
		searchSearchASIN: function(asin) {
			this.$emit('clickSearchItem', asin, 'asin')
		},
		searchSearchItem: function(keyword) {
			this.$emit('clickSearchItem', keyword, 'keywords')
		},
		getCountryObjByCity: function(val) {
			return getCountryObjByCity(val)
		},
		unitConversion: function(v) {
			return unitConversion(v)
		},
		changeDecimal: function(v) {
			return changeDecimal(v)
		},
		fomatTimeStr: function(v) {
			return fomatTimeStr(v)
		}
	},
	watch: {
		dragValue: {
			handler(val) {
				let left = this.$refs['el_table'].bodyWrapper.scrollLeft
				this.$refs['el_table'].bodyWrapper.scrollLeft = (left - val.left)
			},
			deep: true,
		},
		"searchCriteria.page": {
			handler(val) {
				if (this.total <= this.searchCriteria.pageSize * this.searchCriteria.page &&
					!this.$data.loginUser.isLogin && this.total > this.$data.shadowNum) {
					let dom = this.$refs['el_table'].$el.getElementsByClassName('tab-202205300628-tr')[0]
					this.$data.shadowHeight = dom.offsetHeight * this.$data.shadowNum
				}
			},
			deep: true,
		},
	},
	directives: {
		drag: {
			// 指令的定义
			bind: function(el, binding) {
				// el.drag();
				//获取元素
				// var dv = document.getElementById("dv");
				let x = 0;
				let y = 0;
				let ny = 0;
				let nx = 0;
				let isDown = false;
				//鼠标按下事件
				el.onmousedown = function(e) {
					//获取x坐标和y坐标
					x = e.clientX;
					y = e.clientY;
					//开关打开
					isDown = el.offsetWidth < 980;
				};
				//鼠标移动
				window.onmousemove = function(e) {
					if (isDown == false) {
						return;
					}
					//设置样式
					el.style.cursor = "e-resize";
					el.style['user-select'] = 'none';
					//获取最新x和y
					nx = e.clientX;
					ny = e.clientY;
					binding.value.left = (nx - x) / 15
					binding.value.top = ny - y
				};
				//鼠标抬起事件
				el.onmouseup = function() {
					//开关关闭
					isDown = false;
					el.style.cursor = "default";
					el.style['user-select'] = 'text';
				};
			}
		},
	},
}
</script>

<style scoped>
.ranking-up-popover-div {
	min-width: 250px;
}

.table-main-div {
	position: relative;
}

.target-a {
	font-size: 16px;
	color: #409EFF;
	margin-right: 10px;
	font-weight: bolder;
	border-bottom: 1px dashed transparent;
	cursor: pointer;
	max-width: 70%;
	float: left;
}

.target-a:hover {
	border-bottom: 1px dashed #409EFF;
}

.keyword-handle {
	float: left;
}

.no-data-font {
	/* font-weight: bolder; */
	color: #909399;
	font-size: 15px;
}

.loading-div {
	line-height: 42px;
	text-align: center;
}

.asin-box-div {
	padding: 2px 7px;
}

.sort-span {
	display: inline-flex;
	flex-direction: column;
	align-items: center;
	width: 20px;
	vertical-align: middle;
	cursor: pointer;
	overflow: initial;
	position: relative;
}

.sort-span .sort-cart {
	width: 0px;
	height: 0px;
	position: absolute;
	left: 4px;
}

.sort-span .sort-ascending {
	bottom: 12px;
}

.sort-span .sort-descending {
	bottom: 4px;
}

.check-sort {
	color: #409EFF;
}

.not-login-shade-div {
	background: inherit;
	position: absolute;
	left: 0px;
	right: 0;
	bottom: -15px;
	backdrop-filter: blur(6px);
	text-align: center;
}

.last-week-ranking {
	max-width: 80px;
	text-align: left;
	margin: auto;
	line-height: 24px;
}

.open-chart-span {
	border-bottom: 1px currentColor dashed;
	cursor: pointer;
}
</style>
<style>
.tab-202206110508 .el-table__body-wrapper::-webkit-scrollbar {
	/*display: none;*/
}

.tab-202205300628-th th {
	padding: 10px 10px !important;
	color: #909399;
	background-color: #f8f8f8 !important;
}

.tab-202205300628-th th .cell {
	word-break: normal !important;
}

.tab-202205300628-tr:hover > td {
}

.tab-202205300628-tr td {
	/* padding: 10px 0px !important; */
	/* border: 0px !important; */
}
</style>
